import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';

extend(HeaderPrimary.prototype, 'items', function(items) {
//  items.add('Home', <a href="https://enhance.com" target="_blank">Home</a>);
  items.add('Feature list', <a href="https://enhance.com/product/features/platform-features" target="_blank">Feature list</a>);
  items.add('Roadmap', <a href="https://enhance.com/support/product-roadmap" target="_blank">Roadmap</a>);
  items.add('Release notes', <a href="https://enhance.com/support/release-notes" target="_blank">Release notes</a>);
  items.add('Get started', <a href="https://my.enhance.com/order/product?catid=9293e8d5-69d0-7245-233b-d4e853121607&pid=1280d163-9e23-7d43-116a-64610589e572&read_more=1" target="_blank">Get started</a>);
  
});
